//@flow

import {
  getProductCategoryLayoutApi,
  updateProductCategoryLayoutApi,
} from '../api/product-category-layout';
import type {
  ProductCategoryLayoutRequest,
  ProductCategoryLayout,
} from '../../../entities';

export function getProductCategoryLayout(): Promise<ProductCategoryLayout> {
  return getProductCategoryLayoutApi().toPromise();
}

export function updateProductCategoryLayout(
  request: ProductCategoryLayoutRequest
): Promise<ProductCategoryLayout> {
  return updateProductCategoryLayoutApi(request).toPromise();
}
